import { View } from "@-/com.npmjs.react-native";
import {
  SCROLL_EDGE_FADE_HEIGHT,
  ScrollEdgeFade,
} from "@-/dev.improve.haniverse.components.ui.scroll-edge-fade";
import { useSpaceSurfaceColorVariable } from "@-/dev.improve.haniverse.components.ui.space-backdrop";
import type { PrimaryControlsStripToolbarSurface } from "@-/dev.improve.haniverse.contexts.primary-controls-strip.toolbar-height";

/** Header-owned overlay: screen contents and controls are never alpha-masked. */
export function PrimaryControlsStripFade({
  height = SCROLL_EDGE_FADE_HEIGHT,
  overlap = 0,
  surface,
  top,
}: {
  height?: number;
  overlap?: number;
  /** The focused top bar's surface, which the fade continues. */
  surface: PrimaryControlsStripToolbarSurface;
  top: number;
}) {
  const chromeColorVariable = useSpaceSurfaceColorVariable("--color-muted");
  const surfaceColorVariable =
    surface === "surface"
      ? "--color-surface"
      : surface === "page"
        ? "--color-background"
        : chromeColorVariable;
  return (
    <View
      className="absolute inset-x-0 z-40"
      pointerEvents="none"
      style={{ height: height + overlap, top: top - overlap }}
    >
      {/* Feather into the toolbar's bottom gutter before becoming opaque. Starting
          opaque at its boundary cuts off the native glass controls' soft shadows. */}
      {overlap > 0 ? (
        <View className="absolute inset-x-0 top-0" style={{ height: overlap }}>
          <ScrollEdgeFade
            edge="bottom"
            height={overlap}
            surfaceColorVariable={surfaceColorVariable}
          />
        </View>
      ) : null}
      <View className="absolute inset-x-0 bottom-0" style={{ height }}>
        <ScrollEdgeFade edge="top" height={height} surfaceColorVariable={surfaceColorVariable} />
      </View>
    </View>
  );
}
